import { apiSlice } from '../../api/api-slice';
import { CardsPersonageRequest } from 'types/card/card-personage-list';

export const creatCardsPersonage = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addPersonage: builder.mutation<void, CardsPersonageRequest>({
            query: (cardsPersonageRequest: CardsPersonageRequest) => ({
                url:
                    `/personage/add-personage/` +
                    cardsPersonageRequest.cardSphereId,
                method: 'POST',
                body: { ...cardsPersonageRequest },
            }),
        }),
    }),
});
export const { useAddPersonageMutation } = creatCardsPersonage;
